import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const EducationDetails = ({ educationList }) => {
  const { t } = useTranslation();

  return (
    <>
      {educationList?.education?.length > 0 &&
        educationList?.education[0]?.institutionName != "" &&
        educationList?.education[0]?.institutionName != null &&
        educationList?.education[0]?.institutionName != undefined && (
          <div className="details-subheader">{t(`Clinicaleducation`)}:</div>
        )}

      {educationList?.education?.length > 0 &&
        educationList?.education?.map((edu, indexEdu) => (
          <span key={indexEdu}>
            {edu?.institutionName !== null && (
              <>
                {" "}
                <span style={{ color: "#000" }}>
                  {edu?.institutionName}
                  {indexEdu < educationList?.education?.length - 1 ? (
                    <br />
                  ) : (
                    ""
                  )}
                </span>{" "}
              </>
            )}
          </span>
        ))}
    </>
  );
};

EducationDetails.propTypes = {
  educationList: PropTypes.object,
};

export default EducationDetails;
